import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3.5, 3.5, 5.875, 3.5),

    '& > .MuiGrid-item': {
      marginBottom: theme.spacing(2.5),
    },
  },
  actions: {
    marginTop: theme.spacing(2),
  },
  qrIcon: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
  },
}));
